export default __webpack_public_path__ + "static/media/nz.1bc2256d.svg";